import React, { useState, useCallback, useMemo } from "react";
import { INVALIDATE_CACHE } from "../mutations";
import { useMutationWithErrorHandling } from "hooks/errorHandling";
import { useTranslation } from "react-i18next";
import { Button, Card, CardContent, Grid } from "@material-ui/core";
import ActionsDialog from "features/common/components/ActionsDialog";
import SectionTitle from "features/common/components/SectionTitle";
import { addToast } from "components/notifications";
import { useApolloClient } from "@apollo/client";
import { defaultApolloCache } from "constants/defaultApolloCache";

const InvalidateCacheContainer = () => {
  const { t } = useTranslation();

  const [invalidateBtnDisabled, setInvalidateBtnDisabled] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const client = useApolloClient();

  const [invalidateCache] = useMutationWithErrorHandling(INVALIDATE_CACHE, {
    onCompleted: () => {
      setInvalidateBtnDisabled(false);
      client.cache.reset();
      client.cache.restore(defaultApolloCache);
      addToast(t("ToastNotifications.Success"), "success");
    },
    onError: () => {
      setInvalidateBtnDisabled(false);
    },
  });

  const handleOpen = useCallback(() => {
    setOpenDialog(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setOpenDialog(false);
  }, []);

  const dialogActions = useMemo(
    () => [
      {
        caption: t("Dialog.No"),
        handle: () => {
          return true;
        },
      },
      {
        caption: t("Dialog.Yes"),
        handle: () => {
          setInvalidateBtnDisabled(true);
          invalidateCache();
          return true;
        },
      },
    ],
    [t, invalidateCache]
  );

  return (
    <Card>
      <CardContent>
        <SectionTitle title={t("General settings")} />
        <Grid container justifyContent="flex-end">
          <Grid item>
            <Button
              id="invalidateCache_invalidateCacheButton"
              color="primary"
              onClick={handleOpen}
              disabled={invalidateBtnDisabled}
            >
              {invalidateBtnDisabled
                ? t("Settings.InvalidateCache.InvalidatingCache")
                : t("Settings.InvalidateCache.InvalidateCache")}
            </Button>
            <ActionsDialog
              open={openDialog}
              handleClose={handleCloseDialog}
              title={t("Dialog.Warning")}
              message={t("Settings.InvalidateCache.InvalidateCacheDialog")}
              actions={dialogActions}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default InvalidateCacheContainer;
